module.exports = __webpack_public_path__ + "img/solutionImg1.d4c6a80e.png";